//@ts-nocheck
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { toast } from "sonner";
import JobQuestionnaireStagesDetails from "./JobQuestionnaireStagesDetails";
import { fetchQuestionJobData } from "../../features/questionnaire/questionnaireSlice";

const JobQuestionnaireContainer: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [pipelineData, setPipelineData] = useState<any>(null);
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
  const dispatch = useAppDispatch();
  const [boardsFetched, setBoardsFetched] = useState<any[]>([]);

  const fetchPipelineData = useCallback(async () => {
    if (!baseId || !jobId) {
      toast.error("Invalid Base ID or Job ID");
      setLoading(false);
      return;
    }

    try {
      const response = await dispatch(
        fetchQuestionJobData({
          baseId: Number(baseId),
          JobId: jobId,
        }),
      );

      if (
        response.meta.requestStatus === "fulfilled" &&
        response.payload?.data
      ) {
        setPipelineData(response.payload.data);
        setBoardsFetched(response.payload.data);
      }
    } catch (error) {
      console.error("Error fetching pipeline details:", error);
      toast.error("Failed to fetch pipeline details");
    } finally {
      setLoading(false);
    }
  }, [baseId, jobId, dispatch]);

  // Add useEffect to fetch data when component mounts
  useEffect(() => {
    fetchPipelineData();
  }, [fetchPipelineData]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh_-_5rem)]">
        <div className="simple-spinner-loader">
          <span></span>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* {boardsFetched && Array.isArray(boardsFetched) && boardsFetched.length > 0  || pipelineData && Array.isArray(pipelineData) && pipelineData?.length > 0 ? ( */}
      <JobQuestionnaireStagesDetails
        pipelineData={pipelineData}
        setPipelineData={setPipelineData}
        boardsFetched={boardsFetched}
        setBoardsFetched={setBoardsFetched}
      />
      {/* ) : (
                <JobQuestionnaireDetails
                    pipelineData={pipelineData}
                    setPipelineData={setPipelineData}
                    boardsFetched={boardsFetched}
                    setBoardsFetched={setBoardsFetched}
                />
            )} */}
    </>
  );
};

export default JobQuestionnaireContainer;
